import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { http_get } from "utils/axios";

const initialState = {
  announcementList: [],
  announcementDetail: {},
};

export const announcementList = createAsyncThunk(
  "announcement/list",
  async (data, { rejectWithValue }) => {
    try {
      return await http_get(
        `education/siswa/notification?order_by=timestamp,DESC`,
        true,
        data
      );
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const announcementDetail = createAsyncThunk(
  "announcement/detail",
  async (data, { rejectWithValue }) => {
    try {
      return await http_get(
        `education/siswa/notification/${data.id_notifikasi}`,
        true,
        data
      );
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

const announcementReducer = createSlice({
  name: "announcement",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(announcementList.fulfilled, (state, action) => {
        state.announcementList = action.payload.data.data;
      })
      .addCase(announcementDetail.fulfilled, (state, action) => {
        state.announcementDetail = action.payload.data.data;
      });
  },
});

export const selectAnnouncementList = (state) =>
  state.announcement.announcementList;
export const selectAnnouncementDetail = (state) =>
  state.announcement.announcementDetail;

export default announcementReducer.reducer;
